import React from 'react';

export const Loading = ({ message = 'Loading...' }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px',
      minHeight: '400px',
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        border: '4px solid #e5e7eb',
        borderTop: '4px solid #3b82f6',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}></div>
      <p style={{
        marginTop: '16px',
        fontSize: '14px',
        color: '#6b7280',
      }}>
        {message}
      </p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export const ErrorMessage = ({ message, onRetry }) => {
  return (
    <div style={{
      padding: '24px',
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: '8px',
      textAlign: 'center',
    }}>
      <p style={{
        color: '#dc2626',
        fontSize: '14px',
        margin: '0 0 16px 0',
      }}>
        {message || 'An error occurred while loading data'}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: '8px 16px',
            backgroundColor: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            cursor: 'pointer',
            fontWeight: 500,
          }}
        >
          Try Again
        </button>
      )}
    </div>
  );
};

export const StatCard = ({ title, value, subtitle, icon: Icon, color = '#3b82f6' }) => {
  return (
    <div style={{
      backgroundColor: 'white',
      padding: '24px',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid #e5e7eb',
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '16px',
      }}>
        <h3 style={{
          fontSize: '14px',
          fontWeight: 500,
          color: '#6b7280',
          margin: 0,
        }}>
          {title}
        </h3>
        {Icon && (
          <div style={{
            padding: '8px',
            backgroundColor: `${color}15`,
            borderRadius: '8px',
          }}>
            <Icon size={20} color={color} />
          </div>
        )}
      </div>
      <div style={{
        fontSize: '32px',
        fontWeight: 700,
        color: '#111827',
        marginBottom: '8px',
      }}>
        {value}
      </div>
      {subtitle && (
        <div style={{
          fontSize: '13px',
          color: '#6b7280',
        }}>
          {subtitle}
        </div>
      )}
    </div>
  );
};
